var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "border" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex gap-2 bg-gray-100 text-gray-600 line-height-10 p-1",
        },
        [
          _vm.isEditMode
            ? _c(
                "Button",
                {
                  attrs: {
                    disabled: _vm.isPickButtonDisabled,
                    title: "Pick from the approved message list",
                  },
                  on: { click: _vm.pick },
                },
                [_c("i", { staticClass: "fas fa-list fa-fw" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEditMode
            ? _c(
                "Button",
                {
                  attrs: { disabled: _vm.isEmpty, title: "Clear" },
                  on: { click: _vm.clear },
                },
                [_c("i", { staticClass: "fas fa-trash-alt fa-fw" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPickMode
            ? _c(
                "Button",
                {
                  attrs: { disabled: !_vm.hasCurrent, title: "Confirm" },
                  on: { click: _vm.confirm },
                },
                [_c("i", { staticClass: "fas fa-check fa-fw" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPickMode
            ? _c(
                "Button",
                { attrs: { title: "Cancel" }, on: { click: _vm.cancel } },
                [_c("i", { staticClass: "fas fa-times fa-fw" })]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isEditMode
        ? _c(
            "div",
            [
              _c("TextInput", {
                attrs: {
                  value: _vm.text,
                  type: "textarea",
                  autosize: { minRows: 1, maxRows: 6 },
                  resize: "none",
                  readonly: _vm.isEditControlDisabled,
                  placeholder: "Write down a message here",
                },
                on: { input: _vm.onTextInput },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "attachments",
                      fn: function () {
                        return [_vm._t("attachments")]
                      },
                      proxy: true,
                    },
                    {
                      key: "bottom-left-tools-before",
                      fn: function () {
                        return [_vm._t("bottom-left-tools-before")]
                      },
                      proxy: true,
                    },
                    {
                      key: "bottom-left-tools-after",
                      fn: function () {
                        return [_vm._t("bottom-left-tools-after")]
                      },
                      proxy: true,
                    },
                    {
                      key: "bottom-right-tools",
                      fn: function () {
                        return [_vm._t("bottom-right-tools")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isPickMode
        ? _c("ApprovedMessagesList", {
            staticClass: "px-2 pt-2",
            attrs: { url: _vm.approvedMessageListUrl },
            on: { select: _vm.onSelect },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }